//The time is displayed in minutes
const ONE_HOUR_MINUTES = 60

export default Object.freeze({
    en: [
        {
            label: '24 hours',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '23 hours',
            value: 23 * ONE_HOUR_MINUTES,
        },
        {
            label: '22 hours',
            value: 22 * ONE_HOUR_MINUTES,
        },
        {
            label: '21 hours',
            value: 21 * ONE_HOUR_MINUTES,
        },
        {
            label: '20 hours',
            value: 20 * ONE_HOUR_MINUTES,
        },
        {
            label: '19 hours',
            value: 19 * ONE_HOUR_MINUTES,
        },
        {
            label: '18 hours',
            value: 18 * ONE_HOUR_MINUTES,
        },
        {
            label: '17 hours',
            value: 17 * ONE_HOUR_MINUTES,
        },
        {
            label: '16 hours',
            value: 16 * ONE_HOUR_MINUTES,
        },
        {
            label: '15 hours',
            value: 15 * ONE_HOUR_MINUTES,
        },
        {
            label: '14 hours',
            value: 14 * ONE_HOUR_MINUTES,
        },
        {
            label: '13 hours',
            value: 13 * ONE_HOUR_MINUTES,
        },
        {
            label: '12 hours',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 hours',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 hours',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 hours',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 hours',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 hours',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 hours',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 hours',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 hours',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 hours',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour 30 minutes',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '30 minutes',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: 'Immediately',
            value: '0',
        },
    ],
    sr: [
        {
            label: '24 sata',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '23 sata',
            value: 23 * ONE_HOUR_MINUTES,
        },
        {
            label: '22 sata',
            value: 22 * ONE_HOUR_MINUTES,
        },
        {
            label: '21 sat',
            value: 21 * ONE_HOUR_MINUTES,
        },
        {
            label: '20 sati',
            value: 20 * ONE_HOUR_MINUTES,
        },
        {
            label: '19 sati',
            value: 19 * ONE_HOUR_MINUTES,
        },
        {
            label: '18 sati',
            value: 18 * ONE_HOUR_MINUTES,
        },
        {
            label: '17 sati',
            value: 17 * ONE_HOUR_MINUTES,
        },
        {
            label: '16 sati',
            value: 16 * ONE_HOUR_MINUTES,
        },
        {
            label: '15 sati',
            value: 15 * ONE_HOUR_MINUTES,
        },
        {
            label: '14 sati',
            value: 14 * ONE_HOUR_MINUTES,
        },
        {
            label: '13 sati',
            value: 13 * ONE_HOUR_MINUTES,
        },
        {
            label: '12 sati',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 sati',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 sati',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 sati',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 sati',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 sati',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 sati',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 sati',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 30 minuta',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '30 minuta',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: 'Odmah',
            value: '0',
        },
    ],
    bih: [
        {
            label: '24 sata',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '23 sata',
            value: 23 * ONE_HOUR_MINUTES,
        },
        {
            label: '22 sata',
            value: 22 * ONE_HOUR_MINUTES,
        },
        {
            label: '21 sat',
            value: 21 * ONE_HOUR_MINUTES,
        },
        {
            label: '20 sati',
            value: 20 * ONE_HOUR_MINUTES,
        },
        {
            label: '19 sati',
            value: 19 * ONE_HOUR_MINUTES,
        },
        {
            label: '18 sati',
            value: 18 * ONE_HOUR_MINUTES,
        },
        {
            label: '17 sati',
            value: 17 * ONE_HOUR_MINUTES,
        },
        {
            label: '16 sati',
            value: 16 * ONE_HOUR_MINUTES,
        },
        {
            label: '15 sati',
            value: 15 * ONE_HOUR_MINUTES,
        },
        {
            label: '14 sati',
            value: 14 * ONE_HOUR_MINUTES,
        },
        {
            label: '13 sati',
            value: 13 * ONE_HOUR_MINUTES,
        },
        {
            label: '12 sati',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 sati',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 sati',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 sati',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 sati',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 sati',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 sati',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 sati',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 30 minuta',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '30 minuta',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: 'Odmah',
            value: '0',
        },
    ],
    ru: [
        {
            label: '24 часа',
            value: 24 * ONE_HOUR_MINUTES,
        },
        {
            label: '23 часа',
            value: 23 * ONE_HOUR_MINUTES,
        },
        {
            label: '22 часа',
            value: 22 * ONE_HOUR_MINUTES,
        },
        {
            label: '21 час',
            value: 21 * ONE_HOUR_MINUTES,
        },
        {
            label: '20 часов',
            value: 20 * ONE_HOUR_MINUTES,
        },
        {
            label: '19 часов',
            value: 19 * ONE_HOUR_MINUTES,
        },
        {
            label: '18 часов',
            value: 18 * ONE_HOUR_MINUTES,
        },
        {
            label: '17 часов',
            value: 17 * ONE_HOUR_MINUTES,
        },
        {
            label: '16 часов',
            value: 16 * ONE_HOUR_MINUTES,
        },
        {
            label: '15 часов',
            value: 15 * ONE_HOUR_MINUTES,
        },
        {
            label: '14 часов',
            value: 14 * ONE_HOUR_MINUTES,
        },
        {
            label: '13 часов',
            value: 13 * ONE_HOUR_MINUTES,
        },
        {
            label: '12 часов',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 часов',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 часов',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 часов',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 часов',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 часов',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 часов',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 часов',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 часа',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 часа',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часа',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час 30 минут',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '30 минут',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: 'Немедленно',
            value: '0',
        },
    ],
})
